import { parsePhoneNumberFromString, getCountries, getCountryCallingCode } from 'libphonenumber-js/max';

export const DEFAULT_SHOP_COUNTRY = 'NE';

// Les anciens numéros nationaux des boutiques de la plateforme sont nigériens.
// Les nouveaux numéros sont toujours enregistrés en E.164, avec leur indicatif.
export function parseShopPhone(value, country = DEFAULT_SHOP_COUNTRY) {
  const raw = String(value || '').trim();
  if (!raw || !/^[+\d\s().-]+$/.test(raw)) return null;
  const input = raw.replace(/^00/, '+');
  const number = parsePhoneNumberFromString(input, { defaultCountry: country, extract: false });
  if (number?.isValid() && !number.ext) return number;
  // Compatibilité avec les anciens contacts enregistrés « 227… » sans +.
  if (!input.startsWith('+') && input.replace(/\D/g, '').startsWith(getCountryCallingCode(country))) {
    const international = parsePhoneNumberFromString('+' + input.replace(/\D/g, ''), { extract: false });
    if (international?.isValid() && !international.ext) return international;
  }
  return null;
}

export function shopWhatsAppUrl(value, message = '') {
  const number = parseShopPhone(value);
  if (!number) return null;
  return `https://wa.me/${number.number.slice(1)}${message ? '?text=' + encodeURIComponent(message) : ''}`;
}

const names = typeof Intl.DisplayNames === 'function' ? new Intl.DisplayNames(['fr'], { type: 'region' }) : null;
export const SHOP_COUNTRIES = getCountries().map(code => ({
  code, name: names?.of(code) || code, callingCode: getCountryCallingCode(code)
})).sort((a, b) => a.code === DEFAULT_SHOP_COUNTRY ? -1 : b.code === DEFAULT_SHOP_COUNTRY ? 1 : a.name.localeCompare(b.name, 'fr'));
